// ═══════════════════════════════════════════════════════════════════════════
// DEMO MOCK DATA — Forwardsflow $1M NCBA Bank Kenya Demo
// All numbers are pre-computed from the financial model.
// Used by DemoDataContext when AutoPilot is active.
// ═══════════════════════════════════════════════════════════════════════════

export const DEMO_BANK = {
  id: 'ncba-demo',
  name: 'NCBA Bank Kenya',
  shortName: 'NCBA',
  creditGrade: 'BB+',
  nplRate: 25,
  capitalAdequacy: 18.2,
  moodysRating: 'B1',
  bisCapitalRatio: 18.2,
  country: 'Kenya',
  assets: '$2.4B',
  tenantId: 'ncba-demo-tenant',
  email: 'james.ochieng@ncba.com',
};

export const DEMO_CAPITAL_CALL = {
  id: 'cc-ncba-001',
  callNumber: 'CC-NCBA-2025-001',
  txnRef: 'CC-NCBA-2025-001',
  bankName: 'NCBA Bank Kenya',
  bankLogo: '🏦',
  bankId: 'ncba-demo',
  bankCountry: 'Kenya',
  bankRating: 'BB+',
  bankNplRate: 25,
  bankCapitalAdequacy: 18.2,
  instrumentType: 'time_deposit',
  currencyPair: 'USD:KES',
  principalAmount: 1000000,
  amount: 1000000,
  interestRate: 15,
  forwardsPremium: 2.5,
  hedgingFee: 0.5,
  fxSpread: 0.05,
  platformFee: 1.0,
  maturityDays: 365,
  maturityMonths: 12,
  status: 'published',
  createdAt: '2025-03-01T09:00:00Z',
  publishedAt: '2025-03-01T09:05:00Z',
  closingDate: '2025-03-15T23:59:59Z',
  expiresAt: '2025-03-15T23:59:59Z',
  spotRate: 128.90,
  currentFxRate: 128.90,
  forwardsRate: 154.68,
  hedgedFxRate: 154.68,
  expectedM2: 3033175000,
  m2Multiplier: 23.53,
  reserveRatio: 4.25,
  description: 'NCBA Bank Kenya is seeking $1M USD for a 12-month time deposit. The deposit will be converted to KES at 128.90 spot and protected by a 12-month forward contract at 154.68 (20% depr. hedge).',
  totalYield: 17.0,
};

export const COMPETING_CALLS = [
  {
    id: 'cc-kcb-001',
    callNumber: 'CC-KCB-2025-001',
    txnRef: 'CC-KCB-2025-001',
    bankName: 'KCB Bank Kenya',
    bankLogo: '🏦',
    bankId: 'kcb-demo',
    bankCountry: 'Kenya',
    bankRating: 'BB',
    bankNplRate: 28,
    bankCapitalAdequacy: 16.8,
    instrumentType: 'time_deposit',
    currencyPair: 'USD:KES',
    principalAmount: 500000,
    amount: 500000,
    interestRate: 13.5,
    forwardsPremium: 2.0,
    hedgingFee: 0.5,
    fxSpread: 0.05,
    platformFee: 1.0,
    maturityDays: 365,
    maturityMonths: 12,
    status: 'published',
    createdAt: '2025-03-01T10:00:00Z',
    publishedAt: '2025-03-01T10:05:00Z',
    closingDate: '2025-03-20T23:59:59Z',
    expiresAt: '2025-03-20T23:59:59Z',
    spotRate: 128.90,
    currentFxRate: 128.90,
    forwardsRate: 152.50,
    hedgedFxRate: 152.50,
    totalYield: 15.0,
    description: 'KCB Bank Kenya $500K time deposit, 12 months, 13.5% APR.',
  },
  {
    id: 'cc-cooperative-001',
    callNumber: 'CC-COOP-2025-001',
    txnRef: 'CC-COOP-2025-001',
    bankName: 'Cooperative Bank',
    bankLogo: '🏦',
    bankId: 'cooperative-demo',
    bankCountry: 'Kenya',
    bankRating: 'BB-',
    bankNplRate: 30,
    bankCapitalAdequacy: 15.4,
    instrumentType: 'time_deposit',
    currencyPair: 'USD:KES',
    principalAmount: 750000,
    amount: 750000,
    interestRate: 14.0,
    forwardsPremium: 2.2,
    hedgingFee: 0.5,
    fxSpread: 0.05,
    platformFee: 1.0,
    maturityDays: 270,
    maturityMonths: 9,
    status: 'published',
    createdAt: '2025-03-02T08:00:00Z',
    publishedAt: '2025-03-02T08:10:00Z',
    closingDate: '2025-03-18T23:59:59Z',
    expiresAt: '2025-03-18T23:59:59Z',
    spotRate: 128.90,
    currentFxRate: 128.90,
    forwardsRate: 150.20,
    hedgedFxRate: 150.20,
    totalYield: 15.7,
    description: 'Cooperative Bank $750K time deposit, 9 months, 14% APR.',
  },
];

export const COUNTRY_RATINGS = [
  {
    country: 'Kenya',
    currency: 'KES',
    moodys: 'B2',
    sp: 'B',
    fitch: 'B+',
    outlook: 'Stable',
    bisCapital: '18.2%',
    reserveRatio: '4.25%',
    gdpGrowth: '5.2%',
    inflation: '6.8%',
    m2Growth: '12.4%',
    flagEmoji: '🇰🇪',
  },
  {
    country: 'Tanzania',
    currency: 'TZS',
    moodys: 'B2',
    sp: 'B+',
    fitch: 'B',
    outlook: 'Stable',
    bisCapital: '17.8%',
    reserveRatio: '6.00%',
    gdpGrowth: '4.8%',
    inflation: '4.2%',
    m2Growth: '9.8%',
    flagEmoji: '🇹🇿',
  },
  {
    country: 'Uganda',
    currency: 'UGX',
    moodys: 'B3',
    sp: 'B',
    fitch: 'B',
    outlook: 'Positive',
    bisCapital: '21.3%',
    reserveRatio: '8.00%',
    gdpGrowth: '6.1%',
    inflation: '8.9%',
    m2Growth: '11.2%',
    flagEmoji: '🇺🇬',
  },
  {
    country: 'Rwanda',
    currency: 'RWF',
    moodys: 'B+',
    sp: 'B+',
    fitch: 'B+',
    outlook: 'Positive',
    bisCapital: '19.6%',
    reserveRatio: '5.00%',
    gdpGrowth: '7.2%',
    inflation: '5.1%',
    m2Growth: '14.3%',
    flagEmoji: '🇷🇼',
  },
  {
    country: 'Nigeria',
    currency: 'NGN',
    moodys: 'B3',
    sp: 'B-',
    fitch: 'B-',
    outlook: 'Stable',
    bisCapital: '14.2%',
    reserveRatio: '10.00%',
    gdpGrowth: '2.9%',
    inflation: '31.7%',
    m2Growth: '38.2%',
    flagEmoji: '🇳🇬',
  },
];

export const DEMO_BANK_RATINGS = [
  {
    id: 'ncba-demo',
    bankName: 'NCBA Bank Kenya',
    country: 'Kenya',
    grade: 'BB+',
    overallScore: 74,
    baselScore: 82,
    operationsScore: 71,
    repaymentScore: 68,
    nplRate: 25,
    capitalAdequacy: 18.2,
    totalAssets: '$2.4B',
    activeDeals: '$128.9M',
    status: 'active',
  },
  {
    id: 'kcb-demo',
    bankName: 'KCB Bank Kenya',
    country: 'Kenya',
    grade: 'BB',
    overallScore: 70,
    baselScore: 78,
    operationsScore: 68,
    repaymentScore: 65,
    nplRate: 28,
    capitalAdequacy: 16.8,
    totalAssets: '$3.1B',
    activeDeals: '$0',
    status: 'active',
  },
  {
    id: 'cooperative-demo',
    bankName: 'Cooperative Bank',
    country: 'Kenya',
    grade: 'BB-',
    overallScore: 66,
    baselScore: 72,
    operationsScore: 64,
    repaymentScore: 61,
    nplRate: 30,
    capitalAdequacy: 15.4,
    totalAssets: '$2.8B',
    activeDeals: '$0',
    status: 'active',
  },
  {
    id: 'stanbic-demo',
    bankName: 'Stanbic Bank Kenya',
    country: 'Kenya',
    grade: 'BBB-',
    overallScore: 80,
    baselScore: 86,
    operationsScore: 79,
    repaymentScore: 76,
    nplRate: 18,
    capitalAdequacy: 20.1,
    totalAssets: '$1.9B',
    activeDeals: '$0',
    status: 'active',
  },
];

// 50 counterparty profiles (represents 1,000 beta clients)
const COUNTERPARTY_NAMES = [
  'Amara Wanjiku', 'Brian Otieno', 'Catherine Njeri', 'David Kamau', 'Esther Achieng',
  'Francis Mwangi', 'Grace Auma', 'Hassan Juma', 'Irene Chebet', 'James Kariuki',
  'Kelvin Omondi', 'Lucy Wambua', 'Moses Njoroge', 'Nancy Adhiambo', 'Oscar Kibet',
  'Patricia Muthoni', 'Quentin Odhiambo', 'Rebecca Wanjala', 'Samuel Kiptoo', 'Tabitha Ndung\'u',
  'Usman Abdi', 'Violet Achieng', 'Wairimu Githae', 'Xavier Ogola', 'Yasmin Hussein',
  'Zipporah Mwangangi', 'Abel Muriithi', 'Beatrice Owino', 'Charles Mutua', 'Diana Aoko',
  'Emmanuel Kilonzo', 'Faith Waweru', 'George Ouma', 'Hannah Rotich', 'Isaac Koech',
  'Jacinta Nyambura', 'Kennedy Ochieng', 'Lilian Maina', 'Martin Wekesa', 'Naomi Jepkemei',
  'Oliver Mwenda', 'Priscilla Atieno', 'Raphael Kiprono', 'Salome Wanjiku', 'Timothy Onyango',
  'Upendo Okeyo', 'Vera Njoroge', 'William Musyoka', 'Xenia Apondi', 'Zaid Baraka',
];

export const DEMO_COUNTERPARTIES = COUNTERPARTY_NAMES.map((name, i) => {
  const score = 450 + Math.floor(Math.sin(i * 1.7) * 150 + Math.cos(i * 0.9) * 80 + 150);
  const clampedScore = Math.min(820, Math.max(380, score));
  const riskCategory = clampedScore >= 700 ? 'very_low' : clampedScore >= 600 ? 'low' : clampedScore >= 500 ? 'medium' : clampedScore >= 400 ? 'high' : 'very_high';
  const dealCount = 1 + (i % 8);
  const onTimeRate = Math.min(98, Math.max(60, 75 + Math.floor(Math.sin(i * 2.3) * 15 + 10)));
  const avgDealSize = 15000 + Math.floor(Math.sin(i * 1.1) * 8000 + 8000);
  const creditLimit = Math.floor(avgDealSize * (1 + clampedScore / 500));
  return {
    id: `cpty-${String(i + 1).padStart(3, '0')}`,
    name,
    phoneNumber: `+2547${String(10000000 + i * 7919).slice(0, 8)}`,
    creditScore: clampedScore,
    riskCategory,
    avgDealSize,
    creditLimit,
    dealCount,
    onTimePaymentRate: onTimeRate,
    onTimeStreak: Math.max(0, dealCount - 1),
    totalSettled: avgDealSize * dealCount,
    status: i < 40 ? 'active' : 'completed',
    joinedDate: `2024-${String(1 + (i % 12)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
  };
});
// Backwards-compatible alias
export const DEMO_BORROWERS = DEMO_COUNTERPARTIES;

// Foreign exchange quotes use snake_case to match the UI component's expected API field names.
// NCBA Treasury is ranked #1 (best rate) — ideal for NCBA pitch demo.
export const DEMO_FX_QUOTES = [
  {
    id: 'fxq-ncba-001',
    bank_name: 'NCBA Treasury',
    bank_id: 'ncba-demo',
    exchange_rate: 128.92,
    spread: 0.02,
    mid_rate: 128.90,
    target_amount: 128920000,
    valid_until: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
    type: 'spot',
    status: 'pending',
    bank_grade: 'BB+',
    settlement_days: 1,
    is_winner: true,
  },
  {
    id: 'fxq-kcb-001',
    bank_name: 'KCB Treasury',
    bank_id: 'kcb-demo',
    exchange_rate: 128.75,
    spread: 0.15,
    mid_rate: 128.90,
    target_amount: 128750000,
    valid_until: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
    type: 'spot',
    status: 'pending',
    bank_grade: 'BB',
    settlement_days: 2,
  },
  {
    id: 'fxq-stanbic-001',
    bank_name: 'Stanbic Treasury',
    bank_id: 'stanbic-demo',
    exchange_rate: 128.65,
    spread: 0.25,
    mid_rate: 128.90,
    target_amount: 128650000,
    valid_until: new Date(Date.now() + 25 * 60 * 1000).toISOString(),
    type: 'spot',
    status: 'pending',
    bank_grade: 'BBB-',
    settlement_days: 2,
  },
];

// Foreign exchange request uses snake_case to match the UI component's expected API field names
export const DEMO_FX_REQUEST = {
  id: 'fxr-horizon-001',
  request_number: 'FXR-HIP-2025-001',
  investor_name: 'Horizon Impact Partners',
  source_currency: 'USD',
  target_currency: 'KES',
  source_amount: 1000000,
  quote_type: 'spot',
  tenor_days: null,
  quotes_deadline: new Date(Date.now() + 60 * 60 * 1000).toISOString(),
  status: 'quoted',
  created_at: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
  quotes: [],
  // Also keep camelCase aliases for DemoDataContext usage
  requestNumber: 'FXR-HIP-2025-001',
  currencyFrom: 'USD',
  currencyTo: 'KES',
  amount: 1000000,
  quoteType: 'spot',
};

export const DEMO_INSTRUMENTS = [
  {
    id: 'inst-ncba-001',
    name: 'NCBA Bank Kenya USD Time Deposit 12M',
    bank: 'NCBA Bank Kenya',
    bankId: 'ncba-demo',
    type: 'Time Deposit',
    currencyPair: 'USD:KES',
    interestRate: 15.0,
    forwardsPremium: 2.5,
    hedgingFee: 0.5,
    platformFee: 1.0,
    totalYield: 17.0,
    amount: 1000000,
    status: 'Active',
    compliance: { kyc: true, aml: true },
    createdAt: '2025-03-01T09:00:00Z',
  },
  {
    id: 'inst-kcb-001',
    name: 'KCB Kenya USD Time Deposit 12M',
    bank: 'KCB Bank Kenya',
    bankId: 'kcb-demo',
    type: 'Time Deposit',
    currencyPair: 'USD:KES',
    interestRate: 13.5,
    forwardsPremium: 2.0,
    hedgingFee: 0.5,
    platformFee: 1.0,
    totalYield: 15.0,
    amount: 500000,
    status: 'Active',
    compliance: { kyc: true, aml: false },
    createdAt: '2025-03-01T10:00:00Z',
  },
  {
    id: 'inst-cooperative-001',
    name: 'Cooperative Bank USD Time Deposit 9M',
    bank: 'Cooperative Bank',
    bankId: 'cooperative-demo',
    type: 'Time Deposit',
    currencyPair: 'USD:KES',
    interestRate: 14.0,
    forwardsPremium: 2.2,
    hedgingFee: 0.5,
    platformFee: 1.0,
    totalYield: 15.7,
    amount: 750000,
    status: 'Active',
    compliance: { kyc: true, aml: true },
    createdAt: '2025-03-02T08:00:00Z',
  },
];

// The complete financial model for the $1M NCBA Bank Kenya scenario
export const FINANCIAL_MODEL = {
  // Input
  principalUsd: 1_000_000,
  fxSpotRate: 128.90,
  forwardsRate: 154.68,
  forwardsDepreciationPct: 20,
  reserveRatioPct: 4.25,
  m2Multiplier: 23.53,
  loanCycleDays: 30,
  loanCycles: 12,
  nplRatePct: 25,
  betaBorrowers: 1000,

  // KES amounts
  m1Kes: 128_900_000,
  m2Kes: 3_033_175_000,
  grossInterestKes: 139_212_000,
  nplKes: 34_803_000,
  netInterestKes: 104_409_000,

  // USD equivalents (at spot)
  grossInterestUsd: 1_080_000,
  nplUsd: 270_000,
  netInterestUsd: 810_000,

  // Fee waterfall (USD)
  depositOriginationFeeUsd: 10_000,
  fxConversionFeeUsd: 10_000,
  forwardsOriginationFeeUsd: 10_000,
  flowbotOriginationFeeUsd: 22_600,
  fixedFeesTotalUsd: 52_600,

  // P&L split
  bankSharePct: 80,
  platformSharePct: 10,
  investorSharePct: 10,
  bankNetUsd: 648_000,
  platformProfitShareUsd: 81_000,
  investorProfitShareUsd: 81_000,

  // Investor returns
  fixedAprPct: 15,
  fixedInterestUsd: 150_000,
  investorTotalReturnUsd: 231_000,
  investorRoiPct: 23.1,
  investorReceivesUsd: 1_231_000,

  // Forwardsflow total
  platformFixedFeesUsd: 52_600,
  platformTotalUsd: 133_600,

  // T-bill yield & participant impact
  tbillYieldPct: 108,
  platformAprPct: 108,
  informalAprPct: 300,
  participantSavingsPctPa: 192,

  // GDP impact
  m2CreatedUsd: 23_500_000,
};

// ─── Pre-computed demo lifecycle data ─────────────────────────────────────────
// Used as fallback when the /lifecycle/simulate API can't find a confirmed
// deposit call + subscription (e.g., if earlier demo steps didn't reach the API).
const _makeLegs = () => {
  const legs = [
    { id: 'dl-01', leg_type: 'investor_remittance',     status: 'completed', from_entity: 'Horizon Impact Partners', to_entity: 'Forwardsflow Escrow',       amount: 1000000,     currency: 'USD', payment_ref: 'SWIFT-MT103-HIP-2025-001', payment_method: 'swift',           completed_at: '2025-03-01T09:00:00Z' },
    { id: 'dl-02', leg_type: 'ff_receives_usd',         status: 'completed', from_entity: 'Forwardsflow Escrow',     to_entity: 'Forwardsflow Nostro',        amount: 990000,      currency: 'USD', payment_ref: 'FF-ESC-001',               payment_method: 'internal',        completed_at: '2025-03-01T09:05:00Z', notes: '1% origination fee $10,000 deducted' },
    { id: 'dl-03', leg_type: 'fx_conversion',           status: 'completed', from_entity: 'Forwardsflow Nostro',     to_entity: 'NCBA Bank KES Nostro',      amount: 980100,      currency: 'USD', payment_ref: 'FX-NCBA-001',              payment_method: 'fx_conversion',   completed_at: '2025-03-01T09:15:00Z', fx_rate: 128.90, converted_amount: 126350790, notes: '1% foreign exchange fee $9,900 deducted' },
    { id: 'dl-04', leg_type: 'ff_remits_kes',           status: 'completed', from_entity: 'Forwardsflow',            to_entity: 'NCBA Bank Nostro',          amount: 127611000,   currency: 'KES', payment_ref: 'RTGS-FF-NCBA-2025-001',    payment_method: 'rtgs',            completed_at: '2025-03-01T09:20:00Z' },
    { id: 'dl-05', leg_type: 'bank_receives_deposit',   status: 'completed', from_entity: 'NCBA Bank Nostro',        to_entity: 'NCBA M1 Deposit',           amount: 127611000,   currency: 'KES', payment_ref: 'NCBA-DEP-2025-001',        payment_method: 'internal',        completed_at: '2025-03-01T09:25:00Z' },
    { id: 'dl-06', leg_type: 'money_multiplication',    status: 'completed', from_entity: 'M1 Reserve System',       to_entity: 'Network Capital Pool',      amount: 127611000,   currency: 'KES', payment_ref: 'M2-MULT-001',              payment_method: 'fractional_reserve', completed_at: '2025-03-01T10:00:00Z', notes: 'KES 127.6M × 23.53× = KES 3.03B M2 (3-bank cascade, 4.25% CBK reserve)' },
    { id: 'dl-07', leg_type: 'tbill_deployment',         status: 'completed', from_entity: 'NCBA T-Bill Float',       to_entity: '1,000 Beta Participants',   amount: 3033175000,  currency: 'KES', payment_ref: 'MPESA-B2C-BATCH-2025-001', payment_method: 'mpesa_b2c',        completed_at: '2025-03-01T12:00:00Z', notes: 'Avg KES 3,033 per participant across 1,000 T-bill subscriptions @ 108% APR equivalent' },
    { id: 'dl-08', leg_type: 'tbill_maturity',           status: 'completed', from_entity: '1,000 Beta Participants', to_entity: 'NCBA T-Bill Float',         amount: 2430000000,  currency: 'KES', payment_ref: 'MPESA-STK-BATCH-2025-001', payment_method: 'mpesa_stk',        completed_at: '2026-03-01T12:00:00Z', notes: '75% on-time rate after 25% default provision (KES 34.8M provisioned)' },
    { id: 'dl-10', leg_type: 'bank_remits_returns',     status: 'completed', from_entity: 'NCBA Bank Kenya',         to_entity: 'Forwardsflow',              amount: 20881800,    currency: 'KES', payment_ref: 'RTGS-NCBA-FF-RET-001',     payment_method: 'rtgs',            completed_at: '2026-03-01T14:00:00Z', notes: 'FF 10% profit share KES 10.4M + fixed fees' },
    { id: 'dl-11', leg_type: 'ff_receives_kes_return',  status: 'completed', from_entity: 'Forwardsflow',            to_entity: 'Forwardsflow Foreign Exchange Desk',      amount: 20881800,    currency: 'KES', payment_ref: 'FF-INT-RET-001',           payment_method: 'internal',        completed_at: '2026-03-01T14:30:00Z' },
    { id: 'dl-12', leg_type: 'fx_repatriation',         status: 'pending',   from_entity: 'Forwardsflow Foreign Exchange Desk',    to_entity: 'Forwardsflow USD Account',  amount: 1231000,     currency: 'USD', payment_ref: 'FWD-CONTRACT-2025-001',     payment_method: 'forward_contract', fx_rate: 154.68, converted_amount: 190384308, notes: 'Forwards hedge @ 154.68 KES/USD (20% KES depreciation fully hedged)' },
    { id: 'dl-13', leg_type: 'ff_remits_usd_return',    status: 'pending',   from_entity: 'Forwardsflow',            to_entity: 'Horizon Impact Partners',   amount: 1231000,     currency: 'USD', payment_ref: 'SWIFT-MT103-RET-001',       payment_method: 'swift' },
    { id: 'dl-14', leg_type: 'investor_receives_returns', status: 'scheduled', from_entity: 'Forwardsflow',          to_entity: 'Horizon Impact Partners',   amount: 1231000,     currency: 'USD', payment_ref: 'HIP-FINAL-RET-001',         payment_method: 'swift',           notes: '$1M principal + $150K fixed (15% APR) + $81K profit share = $1.231M | ROI 23.1%' },
  ];
  return legs;
};

export const DEMO_LIFECYCLE_DATA = (() => {
  const legs = _makeLegs();
  const legMap = (types) => legs.filter(l => types.includes(l.leg_type));
  const remittanceTypes = ['investor_remittance', 'ff_receives_usd', 'fx_conversion', 'ff_remits_kes', 'bank_receives_deposit'];
  const repatriationTypes = ['bank_remits_returns', 'ff_receives_kes_return', 'fx_repatriation', 'ff_remits_usd_return', 'investor_receives_returns'];
  const completed = legs.filter(l => l.status === 'completed').length;
  return {
    lifecycleId: 'demo-lifecycle-ncba-001',
    summary: { progress: Math.round((completed / legs.length) * 100), completed, totalLegs: legs.length },
    legs,
    phases: {
      remittance:     legMap(remittanceTypes),
      multiplication: legMap(['money_multiplication']),
      disbursement:   legMap(['loan_disbursement', 'loan_repayment']),
      repatriation:   legMap(repatriationTypes),
    },
    tbillPool: {
      m1_deposit:            127611000,
      m2_total:              3033175000,
      pending_maturity:      2893027750,
      money_multiplier:      23.53,
      reserve_ratio:         4.25,
    },
    economics: {
      net_profit_kes:     104409000,
      principal_kes:      127611000,
      net_kes:            127611000,
      repatriation_fx:    154.68,
      gross_interest_kes: 139212000,
      npl_kes:            34803000,
    },
    repayments: null,
    competingOffers: null,
  };
})();
